/**
 * Return a random element from an array or object.
 */
export function sample<T>(arr: T[] | readonly T[]): T;
export function sample<T>(obj: Record<string, T>): T;
export function sample<T>(arrOrObj: T[] | Record<string | number, T>): T {
  if (Array.isArray(arrOrObj)) return arraySample(arrOrObj);
  return objectSample(arrOrObj);
}

function arraySample<T>(arr: T[] | readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

function objectSample<T>(obj: Record<string, T>): T {
  return sample(Object.values(obj));
}
